import { cn } from '../../utils/common-utils.ts';
import ForReviewFlagIcon from '../common/icons/for-review-flag-icon.tsx';

interface IProps {
  className?: string;
  disabled?: boolean;
  compact?: boolean;
  markedForReview: boolean;
  onClick: () => void;
}

export const QuestionLogMarkedForReviewButton = ({
  className,
  disabled = false,
  compact = false,
  markedForReview,
  onClick,
}: IProps) => (
  <button
    type="button"
    aria-label={
      markedForReview
        ? 'Remove question from review list'
        : 'Mark question for review'
    }
    disabled={disabled}
    onClick={(event) => {
      event.stopPropagation();

      if (disabled) {
        return;
      }

      onClick();
    }}
    className={cn(
      'inline-flex items-center justify-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-60',
      compact ? 'h-8 w-8' : 'h-9 w-9',
      markedForReview
        ? 'hover:bg-[#FDEDEE]'
        : 'text-gray hover:bg-light-gray hover:text-dark-blue',
      className,
    )}
  >
    <ForReviewFlagIcon
      className={compact ? 'h-5 w-5' : 'h-[22px] w-[22px]'}
      fillColor={markedForReview ? '#C93A4D' : 'white'}
      strokeColor="#1F1F1F"
    />
  </button>
);
